import axios, { AxiosRequestConfig } from "axios";

// Interfaces
import { ApiResponse } from "../utils/apiResponse";

// Set timeout for Request
axios.defaults.timeout = 120000;

// type Headers = {[key: string]: string}

interface Headers {
  [key: string]: string;
}

export class HttpService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new HttpService();
    }
    return this._instance as HttpService;
  }

  private constructor() {}

  public static readonly defaultConfig: AxiosRequestConfig = {
    headers: { "Content-Type": "application/json" },
  };

  public async get<T>(url: string, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> {
    try {
      const response = await axios.get(url, Object.assign({}, HttpService.defaultConfig, config));

      return ApiResponse.createResponse<T>(response);
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      throw await ApiResponse.createResponse(err.response);
    }
  }

  public async post<T>(
    url: string,
    body?: object | FormData,
    config: AxiosRequestConfig = {}
  ): Promise<ApiResponse<T>> {
    try {
      const response = await axios.post(url, body, Object.assign({}, HttpService.defaultConfig, config));

      return ApiResponse.createResponse<T>(response);
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      throw await ApiResponse.createResponse(err.response);
    }
  }

  public async put<T>(url: string, body?: object | FormData, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> {
    try {
      const response = await axios.put(url, body, Object.assign({}, HttpService.defaultConfig, config));

      return ApiResponse.createResponse<T>(response);
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      throw await ApiResponse.createResponse(err.response);
    }
  }

  public async patch<T>(
    url: string,
    body?: object | FormData,
    config: AxiosRequestConfig = {}
  ): Promise<ApiResponse<T>> {
    try {
      const response = await axios.patch(url, body, Object.assign({}, HttpService.defaultConfig, config));

      return ApiResponse.createResponse<T>(response);
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      throw await ApiResponse.createResponse(err.response);
    }
  }

  public async delete<T>(url: string, config: AxiosRequestConfig = {}): Promise<ApiResponse<T>> {
    try {
      const response = await axios.delete(url, Object.assign({}, HttpService.defaultConfig, config));

      return ApiResponse.createResponse<T>(response);
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }

      throw await ApiResponse.createResponse(err.response);
    }
  }

  // public async head<T>(): void {
  //
  // }

  public static registerBeforeRequest(onSuccess: (request: any) => any, onError: (error: any) => any) {
    axios.interceptors.request.use(onSuccess, onError);
  }

  public static registerAfterResponse(onSuccess: (response: any) => any, onError: (error: any) => any) {
    axios.interceptors.response.use(onSuccess, onError);
  }

  // === UTILS === //
  public createFormData(object: Object, form?: FormData, namespace?: string): FormData {
    const formData = form || new FormData();

    for (let property in object) {
      if (!object.hasOwnProperty(property)) {
        continue;
      }

      const formKey = namespace ? `${namespace}[${property}]` : property;

      if (object[property] instanceof Date) {
        formData.append(formKey, object[property].toISOString());
      } else if (typeof object[property] === "object" && !(object[property] instanceof File)) {
        this.createFormData(object[property], formData, formKey);
      } else {
        formData.append(formKey, object[property]);
      }
    }
    return formData;
  }
}
